import { Box } from "@mui/material";
import { formatDate } from "../../utils/helpers";
import { useSelector } from "react-redux";
import MessageCard from "./MessageCard";
import { createUserLookupMaps } from "../../utils/userHelpers";
import { parseCommentText } from "./discussionUtils/discussionHelpers";
import MessageCardSkeleton from "./MessageCardSkeleton";
import { selectUserDetails } from "../../features/userSlice";

const CommentList = ({
  commentList,
  handleUpdateComment,
  handleDeleteComment,
}: any) => {
  const activeUser = useSelector(selectUserDetails) as any; // Get the logged user details from the Redux store
  const allUsers = useSelector((state: any) => state.user.allUsers); // Get the users from the Redux store
  const { getFullNameByEmail } = createUserLookupMaps(allUsers); //get User name by email

  const { filesList, commentsLoader } = useSelector(
    (state: any) => state.genericCommentsAndFiles
  ); // Get the files list from the Redux store
  const sortedComments = (commentList ?? []).sort(
    (a: any, b: any) =>
      new Date(b.modified).getTime() - new Date(a.modified).getTime()
  );
  return (
    <Box sx={{ mt: 2 }}>
      {commentsLoader
        ? // Show Skeleton loader when loading
          [...Array(5)].map((_, index) => <MessageCardSkeleton key={index} />)
        : sortedComments?.map((comment: any) => (
            <MessageCard
              key={comment.shared_uid}
              user={{
                name: `${
                  comment.created_by && getFullNameByEmail(comment.created_by)
                }`,
                id: activeUser?.user_id,
              }}
              timestamp={formatDate(comment.created)}
              contentBlocks={parseCommentText(
                comment.comment,
                allUsers,
                filesList
              )}
              commentId={comment.shared_uid} //single comment shared_uid
              object_id={comment.object_id} // specific Object shared_uid of the comment
              handleUpdateComment={handleUpdateComment}
              handleDeleteComment={handleDeleteComment}
              canChange={activeUser?.email === comment?.created_by}
              particularComment={comment.comment}
              particularReaction={comment.reactions}
            />
          ))}
    </Box>
  );
};

export default CommentList;
